import { FormattedMessage } from 'react-intl';
import Button from '@rio-cloud/rio-uikit/Button';

import type { DataMockFileMeta } from '../../types';

interface MockFileCardProps {
    file: DataMockFileMeta;
    onOpen: (file: DataMockFileMeta) => void;
}

const MockFileCard = ({ file, onOpen }: MockFileCardProps) => (
    <div className="panel panel-default">
        <div className="panel-body padding-10">
            <div className="display-flex align-items-center justify-content-between">
                <div className="display-flex align-items-center gap-10 overflow-hidden flex-1-1">
                    <span
                        className={`uikit-icon icon-document text-size-20 flex-0-0-auto ${
                            file.type === 'independent' ? 'text-color-primary' : 'text-color-info'
                        }`}
                    />
                    <div className="overflow-hidden flex-1-1">
                        <div className="display-flex align-items-center gap-5 margin-bottom-3">
                            <span
                                className={`label label-condensed label-filled ${
                                    file.type === 'independent' ? 'label-primary' : 'label-info'
                                }`}
                            >
                                {file.type}
                            </span>
                            <span className="text-size-10 text-bold text-color-gray text-uppercase">
                                {file.category}
                            </span>
                        </div>
                        <div
                            className={[
                                'font-family-mono text-size-11 text-color-gray bg-lightest',
                                'padding-x-5 padding-y-2 rounded border border-color-light text-truncate',
                            ].join(' ')}
                        >
                            {file.path}
                        </div>
                    </div>
                </div>
                <Button
                    variant="outline"
                    bsSize="sm"
                    onClick={() => onOpen(file)}
                    className="margin-left-10 flex-0-0-auto"
                >
                    <span className="uikit-icon icon-detail-view margin-right-3" />
                    <FormattedMessage id="intl-msg:mockFileCard.viewFile" />
                </Button>
            </div>
        </div>
    </div>
);

export default MockFileCard;
